'use strict'

export default class CustomFieldsRepeaters {
    #formWrapper;

    #memberNameFields = [];
    #spouseNameFields = [];
    #donationElements;

    constructor() {
        this.#formWrapper = document.querySelector('.levcharity-multi-step-form-wrapper, .donor_crm_edit_wrapper #primary_form, #fieldset-custom-meta_levcharity_custom_field, .woocommerce-EditAccountForm.edit-account');
        if (this.#formWrapper) {
            this.#memberNameFields = [
                this.#formWrapper.querySelector('input[name="first_name"]'),
                this.#formWrapper.querySelector('input[name="last_name"]')
            ];
            this.#spouseNameFields = [
                this.#formWrapper.querySelector('input[name*="[what-is-your-spouse-english-first-name]"]'),
                this.#formWrapper.querySelector('input[name*="[what-is-your-spouse-english-last-name]"]')
            ];

            this.#initialize();
            this.#addEvents();
        }
        this.hideDonationElementsAfterDelay();

    }
    hideDonationElementsAfterDelay(){
        setTimeout(() => {
            this.#donationElements = document.querySelectorAll('.wc-block-components-product-details__donation');
            if (this.#donationElements && this.#donationElements.length > 0) {
                this.#donationElements.forEach(element => {
                    element.remove();
                });
            }
        }, 300);
    }
    #initialize() {
        document.querySelectorAll('[name*="[yartzeits]"][name*="[who-is-the-deceased-related-to]"]')
            ?.forEach(field => {
                this.#updateField(field);
            })
    }

    #addEvents() {
        this.#formWrapper.addEventListener('RepeaterItemAdded', (event) => {
            const {repeaterItem} = event.detail;

            this.#updateField(repeaterItem.querySelector('[name*="[yartzeits]"][name*="[who-is-the-deceased-related-to]"]'));
        });

        this.#formWrapper.addEventListener('change', event => {
            if(event.target.matches('input[name="first_name"],input[name="last_name"],input[name*="[spouse-english-name]"],input[name*="[spouse-english-last-name]"]')) {
                this.#initialize()
            }
        })
    }


    #updateField(field) {
        if (!field) return;

        const memberName = (this.#memberNameFields[0].value + ' ' + this.#memberNameFields[1].value).trim()
        const spouseName = (this.#spouseNameFields[0].value + ' ' + this.#spouseNameFields[1].value).trim()

        let select;
        if (field.closest('input')) {
            select = document.createElement('select')
            select.name = field.name;
            select.id = field.id;
            select.class = field.class;
            select.dataset.uid = field.dataset.uid;
            select.disabled = field.disabled;
            select.required = field.required;
            select.classList.add('levcharity_select')
        } else {
            select = field;
        }

        select.innerHTML = `<option value="">${field?.placeholder || (field.matches('select') && field?.options[0]?.label) || wp.i18n.__('Please select related person', 'nitzanim')}</option>`;

        if (memberName) {
            const memberOption = document.createElement('option');
            memberOption.value = memberName;
            memberOption.label = memberName + wp.i18n.__(' (You)', 'nitzanim');
            select.appendChild(memberOption)
        }

        if (spouseName) {
            const spouseOption = document.createElement('option');
            spouseOption.value = spouseName;
            spouseOption.label = spouseName + wp.i18n.__(' (Spouse)', 'nitzanim');
            select.appendChild(spouseOption)
        }

        if (!field?.value && select.dataset?.valueIndex) {
            select.value = select.options[select.dataset?.valueIndex]?.value || '';
        } else {
            select.value = field.value;
        }

        if (field.closest('input')) {
            select.addEventListener('change', event => {
                select.dataset.valueIndex = select.selectedIndex;
            })
            field.parentElement.appendChild(select)
            field.remove();
        }

    }
}